module.exports = __webpack_public_path__ + "static/media/excluir.875b2692.png";